import { render, staticRenderFns } from "./SynonymsTable.vue?vue&type=template&id=46ca7530"
import script from "./SynonymsTable.vue?vue&type=script&lang=js"
export * from "./SynonymsTable.vue?vue&type=script&lang=js"
import style0 from "./SynonymsTable.vue?vue&type=style&index=0&id=46ca7530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports